import AiFocusInboxesAPI from 'dashboard/api/aifocus/inboxes';
import { createStore } from './storeFactory';
import { throwErrorMessage } from 'dashboard/store/utils/api';

export default createStore({
  name: 'AiFocusInboxes',
  API: AiFocusInboxesAPI,
  actions: mutations => ({
    get: async ({ commit }, { agentId }) => {
      commit(mutations.SET_UI_FLAG, { fetchingList: true });
      try {
        const response = await AiFocusInboxesAPI.get({ agentId });
        const payload = response.data.payload || response.data || [];
        commit(mutations.SET, payload);
        return payload;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(mutations.SET_UI_FLAG, { fetchingList: false });
      }
    },
    create: async ({ commit }, { agentId, inbox_id }) => {
      commit(mutations.SET_UI_FLAG, { creatingItem: true });
      try {
        const response = await AiFocusInboxesAPI.create({
          agentId,
          inboxId: inbox_id,
        });
        commit(mutations.ADD, response.data);
        return response.data;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(mutations.SET_UI_FLAG, { creatingItem: false });
      }
    },
    delete: async ({ commit }, { agentId, inboxId }) => {
      commit(mutations.SET_UI_FLAG, { deletingItem: true });
      try {
        await AiFocusInboxesAPI.delete({ agentId, inboxId });
        commit(mutations.DELETE, inboxId);
        return inboxId;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(mutations.SET_UI_FLAG, { deletingItem: false });
      }
    },
  }),
});
